/** 从待办「申请中 / 被驳回」进入详情前写入；回仪表盘时读取并清除，恢复 Tab / 搜索 / 页码 */

const STORAGE_KEY = 'pendingApplyingReturn';

const ALLOWED_TABS = new Set(['Applying', 'Rejected']);

const normalizeSnapshot = (parsed) => {
	const pageIndex = Number(parsed?.pageIndex);
	const tab = ALLOWED_TABS.has(parsed?.tab) ? parsed.tab : 'Applying';
	return {
		tab,
		keyword: typeof parsed?.keyword === 'string' ? parsed.keyword : '',
		pageIndex: Number.isInteger(pageIndex) && pageIndex >= 0 ? pageIndex : 0,
	};
};

export const savePendingApplyingReturnSnapshot = ({ keyword = '', pageIndex = 0, tab = 'Applying' } = {}) => {
	if (typeof window === 'undefined') return;
	const safePage = Number(pageIndex);
	const safeTab = ALLOWED_TABS.has(tab) ? tab : 'Applying';
	try {
		window.sessionStorage.setItem(
			STORAGE_KEY,
			JSON.stringify({
				tab: safeTab,
				keyword: typeof keyword === 'string' ? keyword : '',
				pageIndex: Number.isInteger(safePage) && safePage >= 0 ? safePage : 0,
			}),
		);
	} catch {
		/* ignore quota / private mode */
	}
};

/** 只读，不清除（供 mount 初始化；Strict Mode 双调用也安全） */
export const readPendingApplyingReturnSnapshot = () => {
	if (typeof window === 'undefined') return null;
	try {
		const raw = window.sessionStorage.getItem(STORAGE_KEY);
		if (!raw) return null;
		return normalizeSnapshot(JSON.parse(raw));
	} catch {
		return null;
	}
};

export const clearPendingApplyingReturnSnapshot = () => {
	if (typeof window === 'undefined') return;
	try {
		window.sessionStorage.removeItem(STORAGE_KEY);
	} catch {
		/* ignore */
	}
};
